import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { PalaryLogo, GuudLogo, RegionalHeroLogo } from '@shared/assets/logo';
import { i18TranslationNS, Translation } from '@shared/config/i18n';
import { useBrandTheme } from '@shared/lib/brandTheme';

const logoMap = {
	palary: PalaryLogo,
	guud: GuudLogo,
	regionalhero: RegionalHeroLogo,
};

export const BrandLogo = ({ className = '', logoUrl = null, ...props }) => {
	const { t: tT } = useTranslation(i18TranslationNS);
	const { logo, logoUrl: themeLogoUrl } = useBrandTheme();

	const resolvedLogoUrl = logoUrl || themeLogoUrl;
	if (resolvedLogoUrl) {
		return (
			<img
				src={resolvedLogoUrl}
				alt={tT(Translation.LOGO_ALT)}
				className={clsx(className)}
				{...props}
			/>
		);
	}

	const LogoComponent = logoMap[logo] ?? PalaryLogo;
	return (
		<LogoComponent
			className={clsx(className)}
			role='img'
			aria-label={tT(Translation.LOGO_ARIA)}
			focusable='false'
			{...props}
		/>
	);
};
